module.exports = __webpack_public_path__ + "static/img/Viliame-Kikau.bac6963.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Viliame-Kikau.jpg
// module id = SN5y
// module chunks = 0